import * as u from '../utils';

export default () => {
    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('quantity__spinner--minus')) {
            const input = e.target.parentNode.querySelector('input');
            if (input.value > 1) {
                input.value--;
                u.trigger('change', input);
            }
        }
        if (e.target.classList.contains('quantity__spinner--plus')) {
            const input = e.target.parentNode.querySelector('input');
            input.value++;
            u.trigger('change', input);
        }
    });
};
